import { State } from '@progress/kendo-data-query';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FC, useMemo } from 'react';
import ExportExcel, { ExcelOption } from 'src/components/ExportExcel';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';

interface GridToolbarProps {
  onClearFilter: VoidFunction;
  dataState: State;
  excelOption: ExcelOption;
  handleExcelChange: (e: DropDownListChangeEvent) => void;
}

const DepartmentTableModalsToolbar: FC<GridToolbarProps> = ({
  onClearFilter,
  dataState,
  excelOption,
  handleExcelChange,
}) => {
  const isClearFiltersDisabled = useMemo(
    () => !dataState.filter?.filters.length,
    [dataState.filter?.filters.length]
  );

  return (
    <div className="flex items-center justify-between w-full">
      <ClearFilterButton disabled={isClearFiltersDisabled} onClick={onClearFilter} />
      <ExportExcel excelOption={excelOption} onExcelChanged={handleExcelChange} width={200} />
    </div>
  );
};
export default DepartmentTableModalsToolbar;
